import * as STD                            from '@emersya/mpa-std-lib';

import CM                   from '@emersya/mpa-components-manager-lib';

export interface IStandingFooterComponentConfiguration extends CM.DOMComponent.IConfiguration {
};

export class StandingFooterComponent extends CM.DOMComponent<
HTMLDivElement,
StandingFooterComponent,
IStandingFooterComponentConfiguration
> {

	component_DOM : HTMLDivElement;

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingFooterComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});

	};
};
export namespace NS {
	export const Component = StandingFooterComponent;
	export type Component = StandingFooterComponent;
	export type Configuration = IStandingFooterComponentConfiguration;
}
import manifestXMLSource    from './StandingFooter.xml';
import './StandingFooter.scss';

CM.declare({
	id :       'standing-footer',
	type :     StandingFooterComponent,
	manifest : manifestXMLSource
});
